import React from "react";

export const If = (p: { children: React.ReactNode; condition: boolean }) => {
  if (p.condition) return <>{p.children}</>;
  else return <></>;
};
